const IceProcEvent = function( battleState, victim ) {
	this.eventHandle = 'ice_proc';
	this.victimId = victim.uid;
	
	this.execute = () => {
		battleState.onBattleEvent( this );	
	};
};
module.exports = IceProcEvent
